//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockCountData', {
//        templateUrl: 'views/components/views/stockCountData/stockCountData.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'stockCountDataService', function ($stateParams, stateService, utilityService, stockCountDataService) {

//            // #region VARIABLES & DEFINITIONS
            
//            const vm = this;
//            let stockCountDataKeyno = $stateParams.stockcountdata_keyno;

//            vm.model = {
//                stockValueStockButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.menu.stock_keyno }) }
//                ],
//                menu: {},
//                itemsListStockCountDatas: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS
            
//            async function loadMenu() {
//                vm.model.menu = (await stockCountDataService.getMenu({ stockcountdata_keyno: stockCountDataKeyno }))[0];
//            }

//            async function loadStockCountDatas() {
//                if (utilityService.validateParmsValue(vm.model.menu.stockcountdata_keyno) !== true) return;

//                return vm.model.itemsListStockCountDatas = await stockCountDataService.listStockCountDatas({ stockcountdata_keyno: vm.model.menu.stockcountdata_keyno });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'stockcountdataitem':
//                        go({
//                            stockcountdataitem_keyno: '0',
//                            argtype: 'stock_keyno',
//                            argvalue: vm.model.menu.stock_keyno
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadMenu();
//                loadStockCountDatas();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
